// React
import React from 'react';
import { Card, Col, Row } from 'reactstrap';

// Containers Injections
import {
  columns,
  FloatButton,
  PageWrapper,
  LoadingScreen,
  DropdownDatatable,
} from '../../containers/componentsInjection';

export const OfficeListView = ({
  offices,
  handleButton,
  handleNewOffice,
  handleEditOffice,
  handleDeleteOffice,
}) => {
  return (
    <LoadingScreen titleMetaTag="Escritórios" loading={!offices}>
      <PageWrapper title={'Escritórios'}>
        <Row>
          <Col xs={12}>
            <Card>
              <DropdownDatatable
                title="Escritórios"
                titleButton="Novo escritório"
                handleButton={() => handleNewOffice}
                data={offices ? offices : []}
                columns={columns}
                pagination
                persistTableHead
                perPage={10}
                isSearchRemote={false}
                actions={[
                  {
                    id: 1,
                    name: 'edit',
                    label: 'Editar',
                    onPress: handleEditOffice,
                    icon: 'la-pen',
                    classNameColorIcon: 'primary',
                  },
                ]}
                handleDelete={handleDeleteOffice}
              />
            </Card>
          </Col>
        </Row>
        <FloatButton handleButton={() => handleButton('/escritorios/novo')} />
      </PageWrapper>
    </LoadingScreen>
  );
};
